import React from 'react';
import { Box, Typography } from '@mui/material';

const ListItem = ({ Icon, text }) => (
  <Box sx={{ display: 'flex', flex: 1 }}>
    <Icon sx={{ ml: 1, mr: 2, color: 'secondary.dark' }} />
    <Typography variant="body2" textAlign="left">{text}</Typography>
  </Box>
);

export default ListItem;
